import React, { useState } from 'react';
import { useDrag } from 'react-dnd';
import { MdClose } from 'react-icons/md';

const DraggableControlCard = ({ control, index, onRemove }) => {
    const [{ isDragging }, dragRef] = useDrag(() => ({
        type: 'CONTROL', // DnD type
        item: () => ({ index, control, id: control.id }),
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    }));
    
    const COMPLIANCE_STYLES = {
        NIST: "bg-blue-100 text-blue-800 border-blue-300",
        COBIT: "bg-purple-100 text-purple-800 border-purple-300",
        ISO27001: "bg-green-100 text-green-800 border-green-300",
        GDPR: "bg-orange-100 text-orange-800 border-orange-300",
    };
    // State for hover effect
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseDown = (e) => {
        e.stopPropagation(); // Prevent click event from closing the overlay
    };
    //console.log("DraggableControlCard props:", control);

    return (
        <div
            ref={dragRef} // Attach the drag reference
            onMouseDown={handleMouseDown} // Stop propagation
            onMouseEnter={() => setIsHovered(true)}  // Hover in
            onMouseLeave={() => setIsHovered(false)} // Hover out
            className={`relative control-card shadow p-3 mb-2 rounded bg-white bg-opacity-70 backdrop-blur-md border border-gray-300 transition-all duration-300 ease-in-out ${
                isDragging ? 'opacity-50' : ''
            }`}
            style={{
                transform: `translateY(${index * 10}px)`, // Slight stagger effect
                boxShadow: isHovered ? '0px 8px 20px rgba(0, 0, 0, 0.3)' : 'none',  // Large shadow on hover
                cursor: 'pointer',  // Pointer cursor on hover
                opacity: isHovered ? 1 : 0.9,  // Full opacity on hover
                transition: 'all 0.3s ease',  // Smooth transition for shadow and opacity
            }}
        >
            {/* Close Icon */}
            <MdClose
                className="absolute top-1 right-1 text-gray-500 hover:text-red-600 cursor-pointer"
                size={20}
                onClick={(e) => {
                    e.stopPropagation(); // Prevent drag weirdness
                    onRemove(control.id); // ✅ Always remove by id!
                }}
            />

            <h4 className="font-bold">{control.title}</h4>
            <p>Type: {control.type}</p>
            <p>{control.description}</p>


            {Array.isArray(control.complianceTypes) && control.complianceTypes.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-2">
                    {[...new Set(control.complianceTypes)].map((fw) => (
                        <span
                            key={fw}
                            className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${COMPLIANCE_STYLES[fw] || "bg-gray-100 text-gray-700 border-gray-300"}`}
                        >
                            {fw}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DraggableControlCard;